import React, { useState } from "react";
import { Container, TabPane, TabContent } from "reactstrap";
import { List, Activity } from "react-feather";
import classnames from 'classnames';

import Loader       from "~/components/loader"
import OverlayModal from "~/components/overlayModal";
import useToggler   from '~/hooks/useToggler';

import TaskSubmitModal    from "./TaskSubmitModal";
import ActivePaginator    from "./Paginators/Active";
import CompletedPaginator from "./Paginators/Completed";


const Tasks = ()=> {

  const [overlayOpen  , setOverlayOpen]  = useState(false);
  const [selectedTask , setSelectedTask] = useState({});
  const [tab          , setTab]          = useState('active');
  const [reload       , setReload]       = useToggler();

  return (
    <Container className="tasks-page">

      <h1 className="main-title"> Tasks </h1>

      <div className="tab-switcher">
        <p className={classnames({"selected": tab == 'active' })}    onClick={()=> setTab('active')  }> <List /> Active  </p>
        <p className={classnames({"selected": tab == 'completed' })} onClick={()=> setTab('completed') }><Activity /> Completed </p>
      </div>

      <TabContent activeTab={tab} className="m-t-40">
        <TabPane tabId="active"> { reload ?  <Loader type={19} center /> : <ActivePaginator setSelectedTask={setSelectedTask} setOverlayOpen={setOverlayOpen} /> } </TabPane>
        <TabPane tabId="completed"> { reload ?  <Loader type={19} center /> : <CompletedPaginator setSelectedTask={setSelectedTask} setOverlayOpen={setOverlayOpen} /> } </TabPane>
      </TabContent>

      <OverlayModal opened={overlayOpen} title={selectedTask.title} onClose={()=> setOverlayOpen(false)}>
        <TaskSubmitModal
          setOverlayOpen={setOverlayOpen}
          selectedTask={selectedTask}
          setReload={setReload}
        />
      </OverlayModal>

    </Container>
  );
};

export default Tasks;
